import React, { useMemo, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Avatar,
  Typography,
  Box
} from "@mui/material";
// import camera from '../../../../icons/camera.svg';
import { ReactComponent as Camera } from "../../../../icons/camera-fill.svg";
import AlertTypeFile from "../../../../components/AlertTypeFile";
import profileService from "../../../../services/profile.service";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import DialogUploadSucess from "../../../../components/DialogUploadSucess";
import AlertSizeFile from "../../../../components/AlertSizeFile";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import { makeStyles } from "@mui/styles";

const baseStyle = {
  transition: "all .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3"
};

const acceptStyle = {
  borderColor: "#00e676"
};

const rejectStyle = {
  borderColor: "#ff1744"
};

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  minWidth: "100px",
  minHeight: "100px",
  borderRadius: "50%"
};

const thumb = {
  display: "inline-flex",
  width: 100,
  height: 100,
};

const thumbInner = {
  display: "flex",
  minWidth: "100px",
  minHeight: "100px",
  overflow: "hidden",
  width: "100%",
  borderRadius: "50%"
};

const img = {
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "cover"
};
let acceptedFileItemsStatus = false;
let fileRejectionItemsStatus = false;
const useStyles = makeStyles({
  fill: {
    '& > path': {
      fill: "#5DA196"
    },
    '& g > path': {
      fill: "#5DA196"
    },
  },
});
function UploadImages(props) {
  const { t } = useTranslation();
  const [isAlertFileOpen, openAlertFile] = React.useState(false);
  const [isAlert, openAlert] = React.useState(false);
  const [test, setTest] = React.useState(true);
  const [isSuccessDialogOpen, openConfirmDialog] = React.useState(false);
  const [isAcceptedFileItemsStatus, setAcceptedFileItemsStatus] = React.useState(false);
  const [isFileRejectionItemsStatus, setFileRejectionItemsStatus] = React.useState(false);
  const [files, setFiles] = useState([]);
  const { image, valueSelect, statusRemove } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const sendData = (files) => {
    console.log(files, 111);
    props.sendFiles(files)
    openAlert(false)
  }
  const remove = file => {
    const newFiles = [...files];     // make a var for the new array
    newFiles.splice(file, 1);
    setFiles(newFiles);       // remove the file from the array
    sendData(newFiles)
  };
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const dataProfiles = JSON.parse(localStorage.getItem("user"));
  let permission = proxy?.proxy_token !== undefined ? proxy?.permission : dataProfiles?.permission
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    fileRejections,
    open
  } = useDropzone({
    // accept: "image/jpg, image/jpeg, image/png",
    noClick: true,
    noKeyboard: true,
    multiple: false,
    // maxFiles: 1,
    // maxSize: 5242880,
    onDrop: acceptedFiles => {
      if (acceptedFileItemsStatus || fileRejectionItemsStatus) {
        openAlertFile(true)
        openAlert(true)
        // setFiles([])
        // console.log(147);
      } else {
        // console.log(300);
        setFiles(
          acceptedFiles.map(file =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          )
        );
        sendData(acceptedFiles)
        // handleSubmitFiles(acceptedFiles)
      }
    },
    // if(statusRemove) {
    //   console.log(56666);
    // }
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject]
  );

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        {/* <img src={file.preview} style={img} /> */}
        <Avatar
          src={file.preview}
          style={img}
          sx={{
            cursor: "pointer",
            width: 100,
            height: 100,
          }}
        />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files]
  );
  if (valueSelect !== "") {
    if (files.length > 0) {
      if (statusRemove) {
        remove()
      }
    } else if (image !== '') {
      if (statusRemove) {
        props.removeImages()
      }
    }
  }
  const acceptedFileItems = acceptedFiles.map(file => {
    if (file.size > 5 * 1024 * 1024) {
      acceptedFileItemsStatus = true
      fileRejectionItemsStatus = false
    } else if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png") {
      fileRejectionItemsStatus = true
      acceptedFileItemsStatus = false
    } else {
      acceptedFileItemsStatus = false
      fileRejectionItemsStatus = false
    }
  });
  const update = () => {
    openAlertFile(false);
    // openAlert(false)
    fileRejectionItemsStatus = false;
    acceptedFileItemsStatus = false;
  }
  console.log(files.length, 999);
  console.log(acceptedFiles.length, 9);
  return (
    <div className="container" style={{ display: "flex", width: "30%", justifyContent: "center", alignItems: "center", flexFlow: "column" }}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <div {...getRootProps({ style })} style={{ display: "flex", justifyContent: "center", alignItems: "center", flexFlow: "column" }}>
          <input {...getInputProps()} />
          {permission !== undefined && permission !== null ? permission.filter((item) => item.code === "profile_photo_admin").length > 0 ?
            valueSelect !== "" ?
              thumbs.length === 0 ?
                <Avatar
                  src={image}
                  style={thumbsContainer}
                  sx={{
                    cursor: "pointer",
                    width: 100,
                    height: 100,
                  }}
                  onClick={open}
                />
                :
                <aside style={thumbsContainer} onClick={open}>{thumbs}</aside>
              :
              <Avatar
                src={image}
                style={thumbsContainer}
                sx={{
                  width: 100,
                  height: 100,
                }}
              />
            :
            <Avatar
              src={image}
              style={thumbsContainer}
              sx={{
                width: 100,
                height: 100,
              }}
            />
            :
            <Avatar
              src={image}
              style={thumbsContainer}
              sx={{
                width: 100,
                height: 100,
              }}
            />
          }
          <div>{acceptedFileItems}</div>
          {permission !== undefined && permission !== null ?
            permission.filter((item) => item.code === "profile_photo_admin").length > 0 ?
              valueSelect !== "" ?
                < div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0 0 0" }}>
                  {/* <img src={camera} alt="camera" /> */}
                  <Camera className={`${classes.fill}`} />
                  <Typography onClick={open} style={{ fontSize: "12px", lineHeight: "17px", color: "#5DA196", fontWeight: "400", textDecoration: "underline", cursor: "pointer", paddingLeft: "10px" }}>{t(`label.changeProfilePicture`)} </Typography>
                </div>
                :
                < div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0 0 0" }}>
                  {/* <img src={camera} alt="camera" /> */}
                  <Camera />
                  <Typography style={{ fontSize: "12px", lineHeight: "17px", color: "#A0A0A0", fontWeight: "400", textDecoration: "underline", cursor: "pointer", paddingLeft: "10px" }}>{t(`label.changeProfilePicture`)} </Typography>
                </div>
              : null
            : null
          }
          {acceptedFiles.length > 0 && files.length > 0 ?
            acceptedFiles.map(file => (
              <Box pt="10px" >
                <Typography style={{ fontSize: "12px", lineHeight: "17px", color: file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png" ? "#CC6058" : "#5DA196", fontWeight: "300", }}>{t(`label.supportedFiles`)} </Typography>
                <Typography style={{ fontSize: "12px", lineHeight: "17px", color: file.size > 5 * 1024 * 1024 ? "#CC6058" : "#5DA196", fontWeight: "300", }}>{t(`label.maximumFileSize`)} </Typography>
                <Typography style={{ fontSize: "12px", lineHeight: "17px", color: "#AAAAAA", fontWeight: "300", }}>{t(`label.suggestImageSize`)} </Typography>
              </Box>
            ))
            : acceptedFiles.length > 0 && files.length === 0 ?
              acceptedFiles.map(file => (
                <Box pt="10px" >
                  <Typography style={{ fontSize: "12px", lineHeight: "17px", color: file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png" ? "#CC6058" : "#AAAAAA", fontWeight: "300", }}>{t(`label.supportedFiles`)} </Typography>
                  <Typography style={{ fontSize: "12px", lineHeight: "17px", color: file.size > 5 * 1024 * 1024 ? "#CC6058" : "#AAAAAA", fontWeight: "300", }}>{t(`label.maximumFileSize`)} </Typography>
                  <Typography style={{ fontSize: "12px", lineHeight: "17px", color: "#AAAAAA", fontWeight: "300", }}>{t(`label.suggestImageSize`)} </Typography>
                </Box>
              ))
              :
              <Box pt="10px" >
                <Typography style={{ fontSize: "12px", lineHeight: "17px", color: "#AAAAAA", fontWeight: "300", }}>{t(`label.supportedFiles`)} </Typography>
                <Typography style={{ fontSize: "12px", lineHeight: "17px", color: "#AAAAAA", fontWeight: "300", }}>{t(`label.maximumFileSize`)} </Typography>
                <Typography style={{ fontSize: "12px", lineHeight: "17px", color: "#AAAAAA", fontWeight: "300", }}>{t(`label.suggestImageSize`)} </Typography>
              </Box>
          }
          {isAlert ?
            <Typography fontSize={12} lineHeight="21px" color={"#CC6058"} sx={{ textAlign: "center", paddingTop: "10px" }}>{t(`label.uploadFailedPleaseTryAgain`)}</Typography>
            : null
          }
        </div>
        <AlertTypeFile open={isAlertFileOpen} setValue={update} text={t(`label.fileCouldNotBeUploaded`)} />
        <DialogUploadSucess subTitle={"a"} open={isSuccessDialogOpen} setValue={openConfirmDialog} upload={true} text={t(`label.changeProfile`)} />
      </div>
    </div >
  );
}

export default UploadImages;
